/**
 * Pure helpers for YouTube Music import UI status text.
 */
import type { YoutubeMusicSyncResult } from "@memes/shared";

export function formatYoutubeMusicSyncSummary(result: YoutubeMusicSyncResult): string {
  const parts = [
    `${result.added} added`,
    `${result.updated} updated`,
    `${result.skipped} unchanged`,
    `${result.removed} removed`,
    `${result.rejected} rejected`,
  ];
  if (result.pruneBlocked) {
    parts.push("prune blocked (library preserved)");
  }
  return parts.join(", ");
}

export function isFullySynchronized(result: YoutubeMusicSyncResult): boolean {
  return (
    !result.pruneBlocked &&
    result.rejected === 0 &&
    result.failed === 0 &&
    result.rejects.length === 0
  );
}
